/*
 * Breakpoints of the theme for script, where a class like `md:hidden` cannot help. Tailwind writes
 * them into its media queries as values and emits no CSS variable for them, so the value stands
 * here once; `tests/lib/breakpoints.test.ts` holds it to Tailwind's theme and to the brand tokens,
 * which set none of their own.
 */

/** From `md` up (48rem): the sidebar stands beside the page, there is no drawer. */
export const MD_UP_QUERY = "(min-width: 48rem)";
